import { defineMessages } from 'react-intl';

export default defineMessages({
  editDescriptions: {
    id: 'sentinel.components.descriptionPanel.editDescriptions',
    defaultMessage: 'Edit Descriptions',
  },
});



// WEBPACK FOOTER //
// ./src/components/WireDescriptionsPanel/messages.js